import { useState, useEffect, useMemo } from 'react'
import { Tasks } from 'components/common/Tasks'
import { ScheduleTaskModal } from 'components/common/modals/ScheduleTaskModal'
import { useDispatch, useSelector } from 'react-redux'
import * as ACT from '../../../actions'
import { useParams } from 'react-router-dom'
import { toUsersSelect } from 'components/Users/serializers'
import { tasksObjMapper } from 'utils/serializers'

export const companyTasksMapper = tasks => {
  if (!tasks.length) return []
  return [
    {
      sectionName: '',
      tasks: tasksObjMapper(tasks)
    }
  ]
}

const TasksContainer = ({ companyName }) => {
  const [isScheduleTaskModalVisible, setIsScheduleTaskModalOpen] = useState(false)
  const [editTasksModal, setEditTasksModal] = useState(false)
  const [task, setTask] = useState(null)
  const dispatch = useDispatch()
  const tasks = useSelector(state => state.company.tasks)
  const users = useSelector(state => state.users)
  const { id } = useParams()

  const companyTasks = useMemo(() => companyTasksMapper(tasks), [tasks])

  useEffect(() => {
    dispatch({ type: ACT.COMPANY_TASKS_FETCH_REQUESTED, payload: { id } })
  }, [dispatch, id])

  useEffect(() => {
    if (!users?.users?.length) {
      dispatch({
        type: ACT.USERS_FETCH_REQUESTED
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const toggleScheduleTaskModal = (params = {}) => {
    setIsScheduleTaskModalOpen(!isScheduleTaskModalVisible)
    setEditTasksModal(!!params.edit)
    setTask(params.task || null)
  }

  const createTask = task => {
    dispatch({
      type: ACT.CREATE_COMPANY_TASK_REQUESTED,
      payload: {
        task,
        companyId: id
      }
    })
  }

  const updateTask = task => {
    dispatch({
      type: ACT.UPDATE_COMPANY_TASK_REQUESTED,
      payload: {
        task
      }
    })
  }

  const markTaskAsDone = id => {
    dispatch({
      type: ACT.COMPANY_TASK_MARK_COMPLETED_REQUESTED,
      payload: {
        id
      }
    })
  }

  const markTaskAsNotDone = id => {
    dispatch({
      type: ACT.COMPANY_TASK_MARK_NOT_COMPLETED_REQUESTED,
      payload: {
        id
      }
    })
  }

  const deleteTask = task => {
    dispatch({
      type: ACT.DELETE_COMPANY_TASK_REQUESTED,
      payload: {
        task
      }
    })
  }

  return (
    <div style={{ padding: '20px 30px' }}>
      <Tasks
        showScheduleTaskModal={toggleScheduleTaskModal}
        tasks={companyTasks}
        markAsDone={markTaskAsDone}
        markAsNotDone={markTaskAsNotDone}
      />
      {isScheduleTaskModalVisible && (
        <ScheduleTaskModal
          showScheduleTaskModal={isScheduleTaskModalVisible}
          toggleScheduleTaskModal={toggleScheduleTaskModal}
          createTask={createTask}
          updateTask={updateTask}
          users={toUsersSelect(users.users)}
          edit={editTasksModal}
          selectedTask={task}
          markAsDone={markTaskAsDone}
          markAsNotDone={markTaskAsNotDone}
          deleteTask={deleteTask}
          company={{ value: id, label: companyName }}
        />
      )}
    </div>
  )
}

export default TasksContainer
